<script>
import { Pie } from 'vue-chartjs'

import 'chartjs-plugin-piechart-outlabels'
import ChartJsPluginDataLabels from 'chartjs-plugin-datalabels'
import { mapState } from 'vuex'

const ANIMATION_DURATION = 700
const textColor = '#000000'

const configChart = {
  profit: {
    name: 'profit',
    label: '粗利益',
    backgroundColor: '#fec32a',
    defaultData: 0,
    dataIndex: 0
  },
  revenue: {
    name: 'revenue',
    label: '売上高',
    backgroundColor: '#4c92fc',
    defaultData: 100,
    dataIndex: 1
  }
}

export default {
  extends: Pie,

  name: 'RevenueAndProfitPieChart',

  components: { ChartJsPluginDataLabels },

  props: {
    pieChartData: {
      type: Array,
      default: () => []
    }
  },

  data: () => ({
    chartdata: {
      labels: [configChart.profit.label, configChart.revenue.label],
      datasets: [
        {
          datalabels: {
            color: textColor,
            anchor: 'center'
          },
          backgroundColor: [
            configChart.profit.backgroundColor,
            configChart.revenue.backgroundColor
          ],
          borderWidth: 0,
          data: [
            configChart.profit.defaultData,
            configChart.revenue.defaultData
          ]
        }
      ]
    },
    options: {
      responsive: true,
      maintainAspectRatio: true,
      animation: {
        duration: 0
      },
      legend: {
        display: false
      },
      tooltips: {
        enabled: false
      },
      layout: {
        padding: 75
      },
      plugins: {
        datalabels: {
          color: '#fff',
          textAlign: 'center'
        },
        outlabels: {
          text: (l) => '%l',
          textAlign: 'left',
          backgroundColor: '#fff',
          padding: 7,
          color: textColor,
          stretch: 30,
          lineColor: textColor,
          lineWidth: 1,
          font: {
            resizable: true,
            minSize: 14,
            maxSize: 18,
            weight: 500
          }
        }
      }
    }
  }),

  mounted () {
    this.addPlugin(ChartJsPluginDataLabels)
    this.rerenderChart()
  },

  computed: {
    ...mapState(['currentLanguage'])
  },

  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },
    labelFormatter (value, context) {
      const { dataIndex } = context
      const [{ value: revenueValue = 0 }, { value: grossProfitValue = 0 }] =
        this.pieChartData

      if (dataIndex === configChart.revenue.dataIndex) {
        return this.$util.numberWithCommas(revenueValue)
      }

      return `${value}%\n${this.$util.numberWithCommas(grossProfitValue)}`
    },
    rerenderChart () {
      const translatedLabels = this.chartdata.labels.map(label => this.translations(`dashboard.${label}`))
      this.chartdata.labels = translatedLabels
      this.options.plugins.datalabels.formatter = this.labelFormatter
      this.renderChart(this.chartdata, this.options)
    }
  },

  watch: {
    pieChartData: {
      handler (newVal) {
        const [{ rate: revenueRate = 0 }, { rate: grossProfitRate = 0 }] =
          newVal

        this.options.animation.duration = ANIMATION_DURATION
        this.chartdata.datasets[0].data = [grossProfitRate, revenueRate]
        this.rerenderChart()
      },
      deep: true
    },

    currentLanguage (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.rerenderChart()
      }
    }
  }
}
</script>
